import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiRoutes } from 'environments/api-routes';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    let cloned = req;

    if (req.url.startsWith(apiRoutes.auth.authSession) || req.url.startsWith(apiRoutes.auth.authGoogleRefresh)) {
      const xsrf = this.getCookie('XSRF-TOKEN');
      if (xsrf) {
        cloned = req.clone({ setHeaders: { 'X-CSRF': xsrf } });
      }
    }
    return next.handle(cloned);
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }
}
